import styled from 'styled-components';

export const ToastsContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 20%;
  right: 20%;
  z-index: 1400;
`;
